'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import { tableCellStyles } from './Table.styles'
import { useTableColorScheme, useTableDensity } from './TableContext'

export type TableCellProps = {
  children?: React.ReactNode
  /** Width of the cell — should match the corresponding header cell width. */
  width?: string
  minWidth?: string
  maxWidth?: string
  /**
   * When set, the column grows proportionally with this weight (like CSS
   * flex-grow). Use instead of maxWidth for viewport-proportional columns.
   * flexBasis is set to '0px' so space is distributed purely by weight.
   */
  flexGrow?: number
  align?: 'left' | 'center' | 'right'
}

export const TableCell = ({
  children,
  width,
  minWidth,
  maxWidth,
  flexGrow,
  align = 'left',
}: TableCellProps) => {
  const colorScheme = useTableColorScheme()
  const density = useTableDensity()
  return (
    <Box
      {...tableCellStyles(colorScheme, align, density)}
      style={{
        flexBasis: minWidth ?? width ?? '0px',
        flexGrow: flexGrow ?? 0,
        flexShrink: flexGrow !== undefined ? 0 : 1,
        minWidth: minWidth ?? width,
        maxWidth: maxWidth,
      }}
    >
      {align === 'left' ? (
        <Box
          as='span'
          display='block'
          minWidth={0}
          overflow='hidden'
          textOverflow='ellipsis'
          whiteSpace='nowrap'
        >
          {children}
        </Box>
      ) : (
        children
      )}
    </Box>
  )
}
